<template>
	<div class="edit-container">
		<div class="top">
			<div>Edit Dashboard</div>
			<CloseIcon class="top-close" @click="$emit('editClose')" />
		</div>
		<div class="button">
			<div
				class="button-item"
				:class="active_cancel ? 'button-cancel-active' : 'button-cancel'"
				@click="onCancel"
			>
				CANCEL
			</div>
			<div class=" button-item button-save" @click="$emit('editClose')">
				SAVE CHANGES
			</div>
		</div>
		<div class="content">
			<div v-for="item in local_items" :key="item.title">
				<v-checkbox
					v-if="!item.disabled"
					light
					color="#00AAFD"
					:label="item.title"
					:input-value="item.visible"
					@change="onChange(item.name)"
				></v-checkbox>
			</div>
		</div>
	</div>
</template>
<script>
import CloseIcon from '@/components/icons/close';

export default {
	name: 'DashboardEdit',
	data() {
		return {
			local_items: this.items,
			active_cancel: false,
			origin_items_visible: null,
		};
	},
	props: {
		items: {
			type: Object,
			default: () => {},
		},
	},
	components: {
		CloseIcon,
	},
	created() {
		this.preserveValue() ;
	},
	methods: {
		preserveValue() {
			const items = {};
			for (let [key, value] of Object.entries(this.items)) {

				items[key] = value.visible;
			}
			this.origin_items_visible = items;
		},
		onChange(name) {
			if (!this.active_cancel) {
				this.active_cancel = !this.active_cancel;
			}
			this.local_items[name].visible = !this.local_items[name].visible;
		},
		onCancel() {
			if(this.active_cancel) {
				for (const [key,value] of Object.entries(this.origin_items_visible)) {
					this.local_items[key].visible = value;
				}
				this.active_cancel = false;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.edit-container {
  width: 400px;
  height: calc(100vh - 48px);
  background: #ffffff;
}
.top {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  color: #000000;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
  padding: 21px 36px 0 36px;
}
.top-close {
  width: 16px;
  height: 16px;
  margin: 4px 4px;
  &:hover {
    cursor: pointer;
  }
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 0 36px;
  height: 36px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}
.button-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  
}
.button-cancel {
  background: #ffffff;
  color: rgba(25, 42, 62, 0.36);
  border: 1px solid rgba(25, 42, 62, 0.36);
  width: 124px;
}
.button-cancel-active {
  background: #00aafd;
  color: #ffffff;
  border: 1px solid #00aafd;
  width: 124px;
  &:hover {
    cursor: pointer;
    font-size: 16px;
    font-weight: 800;
  }
}

.button-save {
  background: #00aafd;
  color: #ffffff;
  border: 1px solid #00aafd;
  width: 195px;
  &:hover {
    cursor: pointer;
    font-size: 16px;
    font-weight: 800;
  }
}
.content {
  margin-top: 24px;
  padding: 0 48px;
}
::v-deep {
  .theme--light.v-label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    font-size: 12px;
    color: #192a3e;
  }
  .v-input__control {
    height: 40px;
  }
}
</style>
